<template>
  <div
    :class="{ 'active': isActive }"
    class="item"
    @click="onClick">
    <div class="item-value">
      <div class="data">
        <p class="name">{{ item.firstName | uppercase }} {{ item.lastName | uppercase }}</p>
        <p class="email">{{ item.email }}</p>
      </div>
    </div>
    <div class="item-options">
      <i
        v-if="isFavorit"
        class="icon-star"/>
      <div
        v-if="(profile.role === 'gerente_branch' && !item.userId) || (profile.role === 'gerente_dealer' && !item.branchId)"
        class="badge">
        S/A
      </div>
      <el-dropdown
        trigger="click"
        @command="clickOnOptions">
        <el-button
          type="link"
          class="el-dropdown-link"
          @click.stop="">
          <i class="icon-more-vertical"/>
        </el-button>
        <el-dropdown-menu
          slot="dropdown"
          style="padding: 0px">
          <el-dropdown-item
            v-if="showEdit"
            command="onEdit">
            <span><i class="icon-edit"/> Editar</span>
          </el-dropdown-item>
          <el-dropdown-item
            v-if="!item.userId && profile.role === 'gerente_branch'"
            command="onAssign">
            <span><i class="icon-user"/> Asignar</span>
          </el-dropdown-item>
          <el-dropdown-item
            v-if="item.userId && profile.role === 'gerente_branch'"
            command="onReassign">
            <span><i class="icon-user"/> Reasignar</span>
          </el-dropdown-item>
          <el-dropdown-item
            v-if="profile.role === 'gerente_dealer' && !item.branchId"
            command="onAssignBranch">
            <span><i class="icon-user"/> Asignar sucursal</span>
          </el-dropdown-item>
          <el-dropdown-item
            v-if="profile.role === 'gerente_dealer' && item.branchId && !item.userId"
            command="onAssignBranch">
            <span><i class="icon-user"/> Reasignar sucursal</span>
          </el-dropdown-item>
          <el-dropdown-item
            v-if="profile.role === 'gerente_dealer'"
            command="onFuse">
            <span><i class="icon-user"/> Fusionar</span>
          </el-dropdown-item>
          <el-dropdown-item
            v-if="(profile.role === 'gerente_branch') || (profile.role === 'gerente_dealer' && !item.userId)"
            command="onDelete">
            <span><i class="icon-trash"/> Eliminar</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ListItem',
  props: {
    item: {
      type: Object,
      default: null
    },
    isFavorit: {
      type: Boolean,
      default: false
    },
    isActive: {
      type: Boolean,
      default: false
    },
    showEdit: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    profile () {
      return this.$store.getters['profile/me']
    }
  },
  methods: {
    onClick () {
      this.$emit('click', this.item)
    },
    onEdit () {
      this.$emit('edit', this.item)
    },
    onAssign () {
      this.$emit('assign', this.item)
    },
    onReassign () {
      this.$emit('reassign', this.item)
    },
    onAssignBranch () {
      this.$emit('assignBranch', this.item)
    },
    onFuse () {
      this.$emit('fuse', this.item)
    },
    onDelete () {
      this.$emit('delete', this.item)
    },
    clickOnOptions (command) {
      if (command === 'onEdit') {
        this.onEdit()
      } else if (command === 'onAssign') {
        this.onAssign()
      } else if (command === 'onReassign') {
        this.onReassign()
      } else if (command === 'onAssignBranch') {
        this.onAssignBranch()
      } else if (command === 'onFuse') {
        this.onFuse()
      } else if (command === 'onDelete') {
        this.onDelete()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.item {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  padding: 5px 10px 5px 5px;
  margin: 0 0 10px 0;
  background-color: #ffffff;
  transition: .3s;
  position: relative;
  cursor: pointer;
  border-radius: 3px;
  &.active {
    box-shadow: 0 1px 6px rgba(#3E3E3E, 0.16);
    .item-value {
      padding: 0;
      &::before {
        content: '';
        width: 4px;
        background-color: $primary;
        border-radius: 3px;
        margin-right: 8px;
      }
    }
  }
  &:hover {
    box-shadow: 0 1px 6px rgba(#3E3E3E, 0.16);
  }
  .item-value {
    min-width: 0;
    margin-right: 10px;
    padding: 0 0 0 12px;
    display: flex;
    flex-flow: row nowrap;
    .data {
      padding: 4px 0;
      width: 100%;
      p {
        margin: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        &.name {
          color: #3E3E3E;
          @include font-primary(13px, regular);
          margin-bottom: 3px;
        }
        &.email {
          color: #B5AFAF;
          @include font-primary(12px, regular);
        }
      }
    }
  }
  .item-options{
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    .badge {
      color: #3E3E3E;
      @include font-primary(10px, semibold);
      background-color: #E5E5E5;
      border: 1px solid #9D9D9D;
      border-radius: 3px;
      padding: 6px 8px;
      margin-right: 10px;
    }
    .el-dropdown-link{
      border: none;
      padding: 0;
      &:hover{
        background-color: #ffffff;
      }
      &:focus{
        background-color: #ffffff;
      }
      i{
        color: $icon;
        font-size: 22px;
      }
    }
    .icon-star {
      font-size: 18px;
      color: #E7120E;
      margin-right: 10px;
    }
    .icon-flag {
      font-size: 18px;
      color: #E7120E;
      margin-right: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_shared/list-item.vue